import { render, staticRenderFns } from "./EditShareCertChange.vue?vue&type=template&id=054313fa&"
import script from "./EditShareCertChange.vue?vue&type=script&lang=js&"
export * from "./EditShareCertChange.vue?vue&type=script&lang=js&"
import style0 from "./EditShareCertChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports